import React, { useState, useRef, useEffect } from 'react';
import { Modal, Form, Divider, Row, Col, Input, Select, InputNumber, message } from 'antd';
import FormItemRoutingNumber from '../formItems/routingNumber';
import FormItemAccountNumber from '../formItems/accountNumber';
import LoadingButton from '@mui/lab/LoadingButton';
import FormItemAddress from '../formItems/address';
import { backendPostWithoutRefresh, backendGetRequest, backendPatchWithoutRefresh } from '../../helpers/callBackend';
import { toPrice } from '../../helpers/stringFormat';
const { Option } = Select;

const LogManualAccount = (props) => {
    const [visible, setVisible] = useState(false)

  return (
      <>
          <div
              style={{
                  border: "0px",
                  padding: "0px",
                  cursor: "pointer",
              }}
              onClick={() => setVisible(true)}
          >
              {props.button}
          </div>

          {(visible) && (
              <ModalComponent
                  title={
                      props.type === "edit"
                          ? "Edit Account Details"
                          : "Log Account Manually"
                  }
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  closeModal={() => setVisible(false)}
                  type={props.type}
                  bankId={props.bankId}
                  logManualAccountSuccess={props.logManualAccountSuccess}
              />
          )}
      </>
  );
}



const ModalComponent = (props) => {

    const [loading, setLoading] = useState(false);
    const [current, setCurrent] = useState(0);
    const [formInputs, setFormInputs] = useState({});
    const formRef = useRef(null);

    const next = async () => {
        await formRef.current.validateFields();
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const handleChange = (input) => (e) => {
        if (typeof e === "string" || typeof e === "number") {
            setFormInputs((prevState) => ({
                ...prevState,
                [input]: e,
            }));
        } else if (e.target !== undefined) {
            
            if (input === "current_balance") {
                e.target.value = e.target.value.replace(/\$\s?|(,*)/g, "");
            }

            setFormInputs((prevState) => ({
                ...prevState,
                [input]: e.target.value,
            }));
        } else {
            setFormInputs((prevState) => ({
                ...prevState,
                [input]: e.format("YYYY-MM-DD"),
            }));
        }
    };

    const handleSubmit = async (values) => {
        let data = {
            ...formInputs,
        };

        setLoading(true);

        data.bank_address = `${formInputs.bankStreetLine1}:${formInputs.bankStreetLine2 || " "}:${formInputs.bankCity}:${formInputs.bankState}:${formInputs.bankZipCode}`;
        data.beneficiary_address = `${formInputs.accountStreetLine1}:${formInputs.accountStreetLine2 || " "}:${formInputs.accountCity}:${formInputs.accountState}:${formInputs.accountZipCode}`;
        data.available_balance = formInputs.current_balance;

        if (props.type === "edit") {
            // Edit account
            data.account_id = props.bankId;
            backendPatchWithoutRefresh("/api/bank-account/manual/", data)
                .then((response) => {

                    props.logManualAccountSuccess(response.data.data);
                    setLoading(false);
                    setCurrent(0);

                    props.closeModal()
                })
                .catch((error) => {
                    console.error(error);

                    setLoading(false);
                });
        } else {
            // Create new account
            backendPostWithoutRefresh("/api/bank-account/manual/", data)
                .then((response) => {
                    props.logManualAccountSuccess(response.data.data);

                    setLoading(false);
                    setCurrent(0);

                    if (formRef.current) {
                        formRef.current.resetFields();
                        setFormInputs({});
                    }

                    props.closeModal();
                })
                .catch((error) => {
                    console.error(error);

                    setLoading(false);
                });
        }
    };

    useEffect(() => {
        if (props.type === "edit" && props.bankId) {

            message.open({
                type: "loading",
                content: "Loading account details...",
                duration: 7.5,
            });

            backendGetRequest(`/api/bank-account/manual/`, {
                params: { bank_account_id: props.bankId },
            }).then((res) => {
                const data = res?.data;
                const accountAddress = data?.beneficiary_address_one_liner?.split(":");
                const bankAddress = data?.bank?.address?.split(":");

                const accountStreetLine1 = accountAddress[0];
                const accountStreetLine2 = accountAddress[1];
                const accountCity = accountAddress[2];
                const accountState = accountAddress[3];
                const accountZipCode = accountAddress[4];

                const bankStreetLine1 = bankAddress[0];
                const bankStreetLine2 = bankAddress[1];
                const bankCity = bankAddress[2];
                const bankState = bankAddress[3];
                const bankZipCode = bankAddress[4];


                const formData = {
                    ...data,
                    current_balance: data.last_current_balance,
                    accountStreetLine1,
                    accountStreetLine2,
                    accountCity,
                    accountState,
                    accountZipCode,
                    bankStreetLine1,
                    bankStreetLine2,
                    bankCity,
                    bankState,
                    bankZipCode,
                };

                setFormInputs(formData);
                formRef.current.setFieldsValue(formData);
            });
        }
        
    }, [props.bankId, props.type]);

    const content = [
        <div style={{ padding: "5%" }}>
            <Row gutter={16}>
                <Col span={8}>
                    <Form.Item
                        label="Account Name"
                        name="account_name"
                        rules={[
                            {
                                required: true,
                                message: "Provide name on account.",
                            },
                            {
                                max: 50,
                                message:
                                    "Account Name must not exceed 50 characters",
                            },
                        ]}
                        onChange={handleChange("account_name")}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        label="Account Description"
                        name="account_description"
                        onChange={handleChange("account_description")}
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        label="Account Type"
                        name="account_type"
                        rules={[{ required: true }]}
                    >
                        <Select
                            placeholder="What is this account used for?"
                            style={{ width: "100%" }}
                            onChange={handleChange("account_type")}
                            allowClear
                        >
                            <Option value="savings">Savings</Option>
                            <Option value="checking">Checking</Option>
                        </Select>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span={12}>
                    <FormItemRoutingNumber
                        label="Routing Number"
                        name="routing_number"
                        onChange={handleChange("routing_number")}
                    />
                </Col>
                <Col span={12}>
                    <FormItemAccountNumber
                        label="Account Number"
                        name="account_number"
                        onChange={handleChange("account_number")}
                    />
                </Col>
            </Row>
            <Row gutter={16}>

                <Col span={24}>
                    <Form.Item
                        label="Current Balance"
                        name="current_balance"
                        onChange={handleChange("current_balance")}
                        rules={[{ required: true }]}
                    >
                        <InputNumber
                            style={{ width: "100%" }}
                            formatter={(value) => {
                                return value
                                    ? `$ ${value}`.replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                      )
                                    : null;
                            }}
                            parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <h4>Beneficiary Details</h4>
            <Divider style={{ marginTop: "5px" }} />

            <Row>
                <Col span={24}>
                    <Form.Item
                        label="Beneficiary Name"
                        name="beneficiary_name"
                        onChange={handleChange("beneficiary_name")}
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <FormItemAddress
                streetLine1={"accountStreetLine1"}
                streetLine2={"accountStreetLine2"}
                city={"accountCity"}
                state={"accountState"}
                zipCode={"accountZipCode"}
                onChange={(value) => handleChange(value)}
                stateInitialValue={formInputs.accountState}
            />

        </div>,
        <div style={{ padding: "5%" }}>
            <h4>Bank Details</h4>
            <Divider style={{ marginTop: "5px" }} />

            <Form.Item
                label="Bank Name"
                name="bank_name"
                rules={[{ required: true }]}
                onChange={handleChange("bank_name")}
            >
                <Input />
            </Form.Item>

            <FormItemAddress
                streetLine1={"bankStreetLine1"}
                streetLine2={"bankStreetLine2"}
                city={"bankCity"}
                state={"bankState"}
                zipCode={"bankZipCode"}
                onChange={(value) => handleChange(value)}
                stateInitialValue={formInputs.bankState}
            />
        </div>,
        <div style={{ padding: "5%" }}>
            <>
                <p
                    style={{
                        marginBottom: "20px",
                        fontWeight: 600,
                        fontSize: "16px",
                    }}
                >
                    Review
                </p>
                <Divider orientation="left">Account Information</Divider>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Account Name
                    </Col>
                    <Col span={10}>{formInputs.account_name}</Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Account Description
                    </Col>
                    <Col span={10}>{formInputs.account_description}</Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Account Type
                    </Col>
                    <Col span={10}>{formInputs.account_type}</Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Routing Number
                    </Col>
                    <Col span={10}>{formInputs.routing_number}</Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Account Number
                    </Col>
                    <Col span={10}>{formInputs.account_number}</Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Current Balance
                    </Col>
                    <Col span={10}>{toPrice(formInputs.current_balance)}</Col>
                </Row>

                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Beneficiary Name
                    </Col>
                    <Col span={10}>{formInputs.beneficiary_name}</Col>
                </Row>

                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Street Line 1
                    </Col>
                    <Col span={10}>
                        {formInputs.accountStreetLine1
                            ? formInputs.accountStreetLine1
                            : ""}
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Street Line 2
                    </Col>
                    <Col span={10}>
                        {formInputs.accountStreetLine2
                            ? formInputs.accountStreetLine2
                            : ""}
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        City
                    </Col>
                    <Col span={10}>
                        {formInputs.accountCity ? formInputs.accountCity : ""}
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        State
                    </Col>
                    <Col span={10}>
                        {formInputs.accountState ? formInputs.accountState : ""}
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Zip Code
                    </Col>
                    <Col span={10}>
                        {formInputs.accountZipCode
                            ? formInputs.accountZipCode
                            : ""}
                    </Col>
                </Row>

                <Divider orientation="left">Bank Information</Divider>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Bank Name
                    </Col>
                    <Col span={10}>{formInputs.bank_name}</Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Street Line 1
                    </Col>
                    <Col span={10}>
                        {formInputs.bankStreetLine1
                            ? formInputs.bankStreetLine1
                            : ""}
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Street Line 2
                    </Col>
                    <Col span={10}>
                        {formInputs.bankStreetLine2
                            ? formInputs.bankStreetLine2
                            : ""}
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        City
                    </Col>
                    <Col span={10}>
                        {formInputs.bankCity ? formInputs.bankCity : ""}
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        State
                    </Col>
                    <Col span={10}>
                        {formInputs.bankState ? formInputs.bankState : ""}
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={10} style={{ textAlign: "left" }}>
                        Zip Code
                    </Col>
                    <Col span={10}>
                        {formInputs.bankZipCode ? formInputs.bankZipCode : ""}
                    </Col>
                </Row>
            </>
            <Divider />
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <LoadingButton
                    disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                    sx={{ fontSize: 12, textTransform: 'none' }}
                    style={{ margin: "3px",  width: "50%" }}
                    loadingPosition="start"
                    loading={loading}
                >
                    Submit
                </LoadingButton>
            </Form.Item>
        </div>,
    ];
    return (
        <Modal
            footer={null}
            width={900}
            title={props.title}
            visible={props.visible}
            onCancel={props.onCancel}
        >
            <div className="steps-content">
                <Form
                    layout="vertical"
                    name="basic"
                    onFinish={handleSubmit}
                    autoComplete="off"
                    ref={formRef}
                >
                    {content[current]}
                </Form>
            </div>
            <div className="steps-action" style={{ textAlign: "center" }}>
                {current > 0 && (
                <LoadingButton
                    disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                    sx={{ fontSize: 12, textTransform: 'none' }}
                    style={{ margin: "3px",  width: "50%" }}
                    onClick={() => prev()}>
                        Previous
                    </LoadingButton>
                )}
                {current < 2 && (
                    <LoadingButton 
                        disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                        sx={{ fontSize: 12, textTransform: 'none' }}
                        style={{ margin: "3px",  width: "50%" }}
                        onClick={() => next()}>
                        Next
                    </LoadingButton>
                )}
            </div>
        </Modal>
    );
}

export default LogManualAccount